import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 13.33a.667.667 0 0 0 .667-.667V3.33a.667.667 0 1 0-1.334 0v9.333a.667.667 0 0 0 .667.667M1.387 8.25q.048.124.14.22l2.666 2.667a.668.668 0 0 0 1.143-.474.67.67 0 0 0-.196-.473L3.607 8.663h7.726a.667.667 0 1 0 0-1.333H3.607L5.14 5.803a.667.667 0 0 0-.217-1.092.67.67 0 0 0-.73.146L1.527 7.523a.7.7 0 0 0-.14.22.67.67 0 0 0 0 .507"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })